import { makeCrud } from "./crud";
import { request } from "./http";

const crud = makeCrud("bookings");

export const fetchBookings  = (filters, signal) => crud.list(filters, signal);
export const fetchBooking   = crud.get;
export const createBooking  = crud.create;
export const updateBooking  = crud.update;
export const deleteBooking  = crud.remove;

export const updateBookingStatus = (id, status) =>
  request(`/bookings/${id}/status`, { method: "PATCH", body: { status } });

/** Turns a booking into a work order (server copies customer/vehicle/service). */
export const convertBookingToWorkOrder = (id) =>
  request(`/bookings/${id}/convert`, { method: "POST" });
